/**
 * angular imports
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
/**
 * constant imports
 */
import { PROFILE_FIELD_CONSTANT } from 'src/app/constants/app.constants';
/**
 * component for all formats of calendar
 */
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  /**
   * Used to emit the selected value.
   */
  @Output() emitSelectedValue: EventEmitter<string> = new EventEmitter();
  /**
   * 
   * emiting event for focus
   */
  @Output() elementTouched: EventEmitter<null> =  new EventEmitter(); 

  public  defaultDate: Date;

  public maxTime = '2300-01-01 00:00:00';

  public isCheckBoxTicked = false;

  @Input() toShowCheckBox = false;

  @Input() checkBoxMessage: string;

  public fieldName: string;

  public currentDate: Date;

  @Input() timeStamp: string;

  @Input()  dateFormat = 'dd M yy';

  @Input() viewFormat: string;

  @Input() showTime = false;
  @Input() isInerrorState = false;

  @Input() timeOnly = false;

  @Input() maxDateValidation = false;
  /**
   * string for label
   */
  @Input() label: string;

  @Input() mandatory=false;
  /**
   * formcontrol name
   */
  @Input() formControlName: string;

  @Input() placeholder: string;

  @Input() selectedValue: string;

  ngOnInit(): void {
      this.currentDate = new Date();
    if (!this.timeOnly) {
      if (this.timeStamp) {
        this.defaultDate = new Date(+this.timeStamp);
      }
      this.emitSelectedValue.emit(this.convertTimeStampToISO(this.defaultDate));
    }
    if (this.timeOnly) {
      this.emitSelectedValue.emit(this.timeStamp);
      if (this.timeStamp) {
        const date = new Date();
        const hour = this.timeStamp.slice(0,2);
        const min = this.timeStamp.slice(-2);
        date.setHours(+hour);
        date.setMinutes(+min);
        this.defaultDate = date;
      }
    }

  }
  /**
   * 
   * @param date get date from timestamp in ISO
   * @returns 
   */
  convertTimeStampToISO(date: Date): string {
    const dformat = [date.getFullYear(),(date.getMonth() < 10 ? '0':'') + (date.getMonth()+1),
    (date.getDate() < 10 ? '0' :'') +  date.getDate(),
    ].join('-')+' '+
    [(date.getHours() < 10 ? '0' : '') + date.getHours(),
    (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(),
    (date.getSeconds() < 10 ? '0' : '') +  date.getSeconds()].join(':');
    return dformat;
  }

  /**
   * check action 
   */
  CheckAction(event): void {
    if (event.target.checked) {
      this.isCheckBoxTicked = true;
      this.defaultDate = null;
      console.log(this.defaultDate);
      this.emitSelectedValue.emit(this.maxTime);
    }
    else {
      this.isCheckBoxTicked = false;
      this.emitSelectedValue.emit(null);
    }
  }
  /**
   * 
   * @param date function to get time
   * @returns 
   */
  getTimeOnly(date: Date): string {
    return [(date.getHours() < 10 ? '0' : '') + date.getHours(),
    (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()].join(':');
  }
  /**
   * 
   * @param event event for date changes
   */
  onSelectedDataChange(event): void {
    if(event) {
      if (this.timeOnly) {
        this.emitSelectedValue.emit(this.getTimeOnly(event));
      }
      else {
        if (this.viewFormat == 'year') {
          if (new Date(event).getFullYear() == 2024) {
          console.log(this.convertTimeStampToISO(new Date(2024, 0, 1, 0, 0, 0, 0)));
          this.emitSelectedValue.emit(this.convertTimeStampToISO(new Date(2024, 0, 1, 0, 0, 0, 0)));
          }
          else {
            this.emitSelectedValue.emit(this.convertTimeStampToISO(event));
          }
        }
        else {
          this.emitSelectedValue.emit(this.convertTimeStampToISO(event));
        }
      }
    }
    else {
      this.emitSelectedValue.emit(null);
    }
  }
  /**
   * emit event on focus of element
   */
  elementFocused(): void {
    this.elementTouched.emit();
  } 
}
